import React from "react";
import './stakeholders.css'
import {Meet_team } from "../components";
import "./../App.css";
const Team = () => {
  return (
    <div>
      <div className="new">
       <Meet_team />
      </div>
    </div>
  );
};

export default Team
;
